import { render, staticRenderFns } from "./dialogMenuGroup.vue?vue&type=template&id=63f06796&"
import script from "./dialogMenuGroup.vue?vue&type=script&lang=js&"
export * from "./dialogMenuGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports